import styled from "styled-components";

interface ISidebarContainer {
  left?: any;
  zIndex?: any;
}
export const SidebarContainer = styled.div<ISidebarContainer>`
  align-items: ${(props) => (props.left ? "flex-start" : "flex-end")};
  background-color: rgba(0, 0, 0, 0.2);
  bottom: 0;
  display: flex;
  flex-direction: column-reverse;
  height: 100vh;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: ${(props) => (props.zIndex ? props.zIndex : "10")};

  .children-container {
    position: relative;
  }
`;

export const CloseButton = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  z-index: 10;

  button {
    background-color: ${(props) => props.theme.colors.white};
    border-radius: 0px 10px 0px 0px;
    border: none;
    cursor: pointer;
    font-weight: 700;
    padding: 1rem 1.3rem;
  }
`;
